// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createWidgetizedFlashbar } from './implementation';
export const InternalFlashbar = createWidgetizedFlashbar();
//# sourceMappingURL=internal.js.map